import React, { Fragment } from 'react'
import { Auth } from 'aws-amplify'
import { Text } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import style from './auth.module.scss'
import { withTranslation } from 'react-i18next'
import { ConfirmSignIn } from 'aws-amplify-react'
import AuthContainer from './AuthContainer'

class MyConfirmSignIn extends ConfirmSignIn {
	state = { isSubmitting: false }

	getApi = formApi => {
		this.formApi = formApi
	}

	goBack = () => {
		this.changeState('signIn')
	}

	handleMfa = async ({ code }) => {
		const { authData: user, t } = this.props
		const mfaType = user.challengeName === 'SOFTWARE_TOKEN_MFA' ? 'SOFTWARE_TOKEN_MFA' : null
		this.setState({ isSubmitting: true })
		try {
			await Auth.confirmSignIn(user, code, mfaType)
			this.checkContact(user)
		} catch(err) {
			this.setState({ isSubmitting: false })
			this.formApi.setError('code', t([`auth_screen.error.${err.code2}`, 'auth_screen.error.default']))
		}
	}

	showComponent(theme, { t } = this.props) {
		return (
			<AuthContainer getApi={this.getApi} className={style.form} onSubmit={this.handleMfa}>
				{({ formState: { values, errors } }) => (
					<Fragment>
						<p>{t('auth_screen.message.complete_mfa')}</p>
						<Divider height={20}/>
						<Text
							errors={errors}
							errorClass={style.formInputError}
							field='code'
							placeholder={t('auth_screen.form.mfa_code')}
							usePlaceholder
							validate={v => (v ? null : t('auth_screen.error.mfa_code_required'))}
							validateOnChange
							autoFocus
						/>
						<Divider height={20}/>
						<Button
							status='active'
							text={t('common.buttons.confirm')}
							type='submit'
							{...this.state.isSubmitting && { loading: true }}
						/>
						<div className={style.linkButton} onClick={this.goBack}>
							{t('auth_screen.button.go_back')}
						</div>
					</Fragment>
				)}
			</AuthContainer>
		)
	}
}

export default withTranslation()(MyConfirmSignIn)
